import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { StateIndicatorCircleState } from '../state-indicator-circle/state.enum';
import { MessageButtonUserVM as UserVM } from './user.vm';
import { TranslateModule } from '@ngx-translate/core';
import { ProfilePicturePipe } from '../../pipes/profile-picture.pipe';
import { LoadingIndicatorComponent } from '../loading-indicator/components/loading-indicator/loading-indicator.component';
import { StateIndicatorCircleComponent } from '../state-indicator-circle/state-indicator-circle.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-message-button',
  templateUrl: './message-button.component.html',
  styleUrls: ['./message-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, StateIndicatorCircleComponent, LoadingIndicatorComponent, ProfilePicturePipe, TranslateModule],
})
export class MessageButtonComponent {
  @Input() public user: UserVM;
  @Output() public buttonClick = new EventEmitter();

  public state = StateIndicatorCircleState;

  public onClick(): void {
    this.buttonClick.emit();
  }
}
